module.exports = __webpack_public_path__ + "static/media/new-york-79.e0befd41.jpg";